import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Section = styled.div<{ withoutMarginTop: boolean }>`
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(8)};
    padding: ${rem(5)} ${rem(5)} ${rem(5)} ${rem(15)};
    margin: 0 0 ${rem(10)} 0;
    display: flex;
    align-items: center;
    width: 100%;
    ${(prop) => (prop.withoutMarginTop ? 'margin-top: 0' : '')};
`;

export const Icon = styled(IconTemplate)`
    svg {
        width: ${rem(24)};
        height: ${rem(24)};
        margin: ${rem(2)} ${rem(5)} 0 0;

        path {
            fill: ${({ theme }) => theme.colors.grey};
            opacity: 0.6;
        }

        @media (min-width: ${breakpoints.md}px) {
            margin-right: ${rem(10)};
        }
    }
`;

export const Input = styled.input`
    width: 90%;
    border: none;
    color: ${({ theme }) => theme.colors.black};
`;
